import {Component, OnDestroy, OnInit} from "@angular/core";
import {LocalisationModalComponent} from "../../localisation-modal/localisation-modal.component";
import {AuthService} from "@fedeltapointofsale/data-client";
import {Router} from "@angular/router";
import {FUIModalsService} from "@fedeltapointofsale/ui";
import {AnalyticsService} from "../../../analytics/analytics.service";
import {AnalyticEvent} from "../../../analytics/analytic-event";

@Component({
    selector: "wbo-localisation-chrome-control",
    templateUrl: "./localisation-chrome-control.component.html",
    styleUrls: ["./localisation-chrome-control.component.scss"]
})
export class LocalisationChromeControlComponent implements OnDestroy, OnInit {
    public modal: LocalisationModalComponent;

    constructor(private modalsService: FUIModalsService,
                public authService: AuthService,
                private router: Router,
                private analyticsService: AnalyticsService) {
    }

    ngOnDestroy() {
        this.modalsService.destroy(this.modal);
    }

    ngOnInit() {
        this.modalsService.create<LocalisationModalComponent>(LocalisationModalComponent).subscribe(
            (modal) => {
                this.modal = modal;
                this.modal.confirm.subscribe(
                    () => {
                        if (this.modal.selectedOutlets.length || this.modal.selectedCustomObjects.length) {
                            this.analyticsService.trackEvent(AnalyticEvent.GLOBAL_LOCALISATION_ENABLE);
                            this.authService.setRestrictedLocalisation(this.modal.selectedOutlets, this.modal.selectedCustomObjects);
                        } else {
                            this.analyticsService.trackEvent(AnalyticEvent.GLOBAL_LOCALISATION_DISABLE);
                            this.authService.clearRestrictedLocalisation();
                        }
                        this.router.navigate([""]);
                    }
                )
            }
        );
    }

    /**
     *
     */
    open(): void {
        this.modalsService.open(this.modal).subscribe((modal) => {
            modal.opened(this.authService.getRestrictedOutlets() || [], this.authService.getRestrictedCustomOutletGroups() || []);
        });
    }
}
